export default __webpack_public_path__ + "static/media/videoTikTok.cd2215ce.svg";